//MUI
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import parse from 'html-react-parser';

function AccordionWidget({sSystemName, cMake})
{
    let systemCSS = require('../config/' + sSystemName + '.css');

    return (
        <div id={"widget_accordion_" + cMake.sName}>
            <h2>{cMake.sTitle}</h2>
            {
                cMake.acItems.map(cItem => (
                    <Accordion>
                        <AccordionSummary>{cItem.sTopic}</AccordionSummary>
                        <AccordionDetails>
                            { cItem.sImage && 
                                <img src={cItem.sImage} width={cItem.sImageWidth} height={cItem.sImageHeight}></img>
                            }
                            { cItem.sText &&
                                <p>{parse(cItem.sText)}</p>
                            }
                            { cItem.sText2 &&
                                <p>{parse(cItem.sText)}</p>
                            }
                            {
                                cItem.asBullets &&
                                <ul>
                                    {cItem.asBullets.map(sBullet => (<li>{sBullet}</li>))}
                                </ul>
                            }
                        </AccordionDetails>
                    </Accordion>
                ))
            }
        </div>
    );
}

export default AccordionWidget